<!--
 * @Author: pengyong
 * @Date: 2020-12-02 23:09:36
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-14 21:25:06
 * @Description: 个人中心- 文件收藏
 * @FilePath: /exhibit/src/views/user/fileCollect.vue
-->
<template>
    <div class="file-collect">
        <HeadLine
            showEdit
            :subTitle="$t('userCenter').edit"
            :count="checkIds.length"
            :isEdit="isEdit"
            @click-edit="clickEdit"
            @click-cancel="clickCancel"
            @click-del="clickDel"
            @click-all="clickAll"
        >
            <span v-if="!hideUserModalSideBar">
                {{ $t("userCenter").collectFile }}
            </span>
            <HeadLineTitle v-else />
        </HeadLine>
        <div class="items" v-if="!noData">
            <div class="item" v-for="item in lists" :key="item.com_doc_id" @click="handleChoose(item)">
                <template v-if="isEdit">
                    <div class="box-bg"></div>
                    <div class="checked" v-if="checkIds.indexOf(item.com_doc_id) > -1"></div>
                    <div class="unchecked" v-else></div>
                </template>
                <img class="icon" :src="require('@/assets/user/file.png')" alt="" />
                <p>{{ item.com_doc.doc_name }}</p>
            </div>
        </div>
        <Empty v-else :text="$t('tips').noCollect" />
    </div>
</template>

<script>
import api from "@/api";
import HeadLine from "./components/HeadLine";
import HeadLineTitle from "./components/HeadLineTitle";
import Empty from "@/components/Empty";
import { exhibition_id } from "@/utils/exhibitId";
import { mapState } from "vuex";
export default {
    components: {
        HeadLine,
        HeadLineTitle,
        Empty
    },
    data() {
        return {
            isEdit: false,
            lists: [],
            checkIds: [],
            noData: false
        };
    },
    computed: {
        ...mapState(["hideUserModalSideBar"])
    },
    mounted() {
        this.getMarkDoc();
    },
    methods: {
        getMarkDoc() {
            api.getMarkDoc({
                exhibition_id
            }).then((res) => {
                if (res.res === 1) {
                    this.lists = res.list || [];
                    this.noData = !this.lists.length;
                }
            });
        },
        handleChoose(item) {
            if (!this.isEdit) {
                window.open(item.com_doc.doc.url);
                return;
            }
            let index = this.checkIds.indexOf(item.com_doc_id);
            if (index === -1) {
                this.checkIds.push(item.com_doc_id);
            } else {
                this.checkIds.splice(index, 1);
            }
        },
        clickEdit() {
            this.isEdit = true;
        },
        clickCancel() {
            this.isEdit = false;
        },
        clickDel() {
            if (!this.checkIds.length) return;
            api.deleteMarkDoc({
                exhibition_id,
                com_doc_id: this.checkIds.join(",")
            }).then((res) => {
                if (res.res === 1) {
                    this.getMarkDoc();
                    this.isEdit = false;
                    this.checkIds = [];
                }
            });
        },
        clickAll(flag) {
            if (flag) {
                this.checkIds = this.lists.map((item) => item.com_doc_id);
            } else {
                this.checkIds = [];
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixins.scss";
.file-collect {
    padding-top: 40px;
    font-size: 14px;
    .items {
        margin-top: 36px;
        display: flex;
        flex-wrap: wrap;
        padding-left: 10px;
        .item {
            text-align: center;
            color: rgba(9, 70, 140, 1);
            line-height: 16px;
            width: 84px;
            margin-right: 42px;
            position: relative;
            p {
                @include textCutOff(2);
                font-weight: 500;
            }
            .icon {
                width: 74px;
                height: 87px;
                margin-bottom: 15px;
            }
            .box-bg {
                // background: rgba(216, 216, 216, 0.7);
                position: absolute;
                width: 100%;
                bottom: 0;
                left: 0;
                right: 0;
                top: 0;
            }
            .checked {
                width: 15px;
                height: 15px;
                border-radius: 13px;
                position: absolute;
                left: 13px;
                top: 11px;
                z-index: 1;
                background: #ea6767 url("~@/assets/user/confirm.png") no-repeat center;
                background-size: contain;
            }
            .unchecked {
                width: 15px;
                height: 15px;
                border-radius: 13px;
                position: absolute;
                left: 13px;
                top: 11px;
                z-index: 1;
                border: 1px solid rgba(0, 0, 0, 0.45);
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/user/fileCollect.vue